import React, { useEffect, useState } from 'react';
import { resp } from '../../../mockdata/dashboard/mock-graph-4';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SummaryBox from '../../../components/Dashboard/SummaryBox/Wallet';
import SummaryBoxesTotalPoint from '../../../components/Dashboard/SummaryBox/TotalPoint';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import LoadingChart from '../../../components/Dashboard/Chart/LoadingChart';
import { useLocation } from 'react-router-dom';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import FilterYear from '../../../components/Dashboard/Filter/Year';
import FileSaver from 'file-saver';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';

const useStyles = makeStyles((theme) => ({
   descContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   loading: {
      height: '300px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
   usedPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#EC068D',
      borderRadius: '2px',
   },
   remainPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#CCCCCC',
      borderRadius: '2px',
   },
   tablesContainer: {
      backgroundColor: 'white',
      padding: 10,
      height: '100%',
      width: '50%',
   },
}));

const PointCompare = () => {
   const classes = useStyles();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingLeaderBoard, setIsLoadingLeaderBoard] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const [totalPoint, setTotalPoint] = useState();
   const [rawPoints, setRawPoints] = useState();
   const [walletLeaderBoards, setWalletLeaderBoards] = useState();
   const location = useLocation();

   const getGraph = (year) => {
      let payload = { year };
      setIsLoading(true);
      Axios.get('/GSB/dashboard/dashboard/GetPointCompareGraph', {
         params: payload,
      })
         .then((resp) => {
            setTotalPoint({
               ...resp.data.totalPoints,
               year,
            });
            setRawPoints(resp.data.rawPoints.wallets);
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(e.response.data.errorAppMessageTh, {
                  variant: 'error',
               });
            } else {
               console.error('site error');
            }
         })
         .finally(() => {
            setIsLoading(false);
         });
   };

   const getLeaderBoard = () => {
      setIsLoadingLeaderBoard(true);
      Axios.get('/GSB/dashboard/dashboard/GetWalletLeaderBoard')
         .then((resp) => {
            setWalletLeaderBoards(resp.data.walletLeaderBoards);
         })
         .catch((e) => {
            if (e.ponse) {
               const response = e.response.data;
               enqueueSnackbar(e.response.data.errorAppMessageTh, {
                  variant: 'error',
               });
            } else {
               console.error('site error');
            }
         })
         .finally(() => {
            setIsLoadingLeaderBoard(false);
         });
   };

   const getChartsOptionsDefault = () => {
      return {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'item',
            formatter: '<strong>{a}</strong> <br/>{b}: {d}%',
         },
         legend: {
            top: '5%',
            left: 'center',
         },
         series: [
            {
               type: 'pie',
               radius: ['30%', '50%'],
               avoidLabelOverlap: false,
               label: {
                  show: false,
               },
               color: ['#EC068D', '#CCCCCC'],
               data: [],
            },
         ],
      };
   };

   const mapOptions = (item) => {
      let options = getChartsOptionsDefault();
      options.series[0].name = item.walletName;
      options.series[0].data = [
         {
            name: 'คะแนนที่ใช้',
            value: item.usedPoints,
         },
         {
            name: 'คะแนนคงเหลือ',
            value: item.remainPoints,
         },
      ];
      const isAllZero = options.series[0].data.every(
         (item) => item.value === 0,
      );
      options.series[0].data = options.series[0].data.map((item) => {
         return {
            ...item,
            itemStyle: { color: isAllZero ? '#CCCCCC' : undefined },
         };
      });
      return options;
   };

   const calculatePercent = (a, b) => {
      let result = ((a / b) * 100).toFixed(2);
      return isNaN(result) ? '-' : result + '%';
   };

   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetWalletLeaderBoard`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            console.log(response.data);
            FileSaver.saveAs(
               new Blob([response.data]),
               'การใช้คะแนนแต่ละกระเป๋า.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };

   useEffect(() => {
      getLeaderBoard();
   }, []);

   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };

   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoading || isLoadingLeaderBoard}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({
                        totalPoint,
                        rawPoints,
                        walletLeaderBoards,
                     }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper style={{ backgroundColor: '#FEF3F7' }}>
            <Box fontSize={20} padding={'10px'}>
               <Typography variant='h5'>
                  เปรียบเทียบคะแนนทั้งหมดและคะแนนที่ใช้ไป
               </Typography>
               <Box marginBottom={'10px'}>
                  {/* <SummaryBox totalPoint={totalPoint} rawPoints={rawPoints} isLoading={isLoading} /> */}
                  <Grid xs={2}>
                     <FilterYear
                        onChangeYear={getGraph}
                        defaultSubmitFirstParams
                     />
                  </Grid>
                  <Box marginTop={'10px'}>
                     <SummaryBoxesTotalPoint
                        totalPoint={totalPoint}
                        isLoading={isLoading}
                     />
                  </Box>
               </Box>
               <Box>
                  {isLoading ? (
                     <LoadingChart show={true} height={300} />
                  ) : (
                     <div className={classes.graphsContainer}>
                        {rawPoints &&
                           rawPoints.map((item, index) => (
                              <Box
                                 key={index}
                                 padding={'10px'}
                                 marginRight={
                                    index !== rawPoints.length - 1 ? '10px' : 0
                                 }
                                 width={'25%'}
                                 style={{ backgroundColor: 'white' }}
                              >
                                 <Box fontSize={24} fontWeight={'bold'}>
                                    {item.walletName}
                                 </Box>
                                 <Box>
                                    อัตราคะแนนทั้งหมดเทียบกับคะแนนที่ใช้ไป
                                 </Box>
                                 <ReactECharts
                                    option={mapOptions(item)}
                                    style={{ height: 300, width: '100%' }}
                                 />
                                 <Box>
                                    <Box
                                       display='flex'
                                       alignItems='center'
                                       justifyContent='space-between'
                                    >
                                       <Box display='flex' alignItems='center'>
                                          <Box
                                             className={classes.usedPointFlag}
                                             mr={1}
                                          />
                                          คะแนนที่ใช้
                                       </Box>
                                       <Box fontSize={20} fontWeight={'bold'}>
                                          {costFormat(item.usedPoints)}
                                       </Box>
                                    </Box>
                                    <Box
                                       display='flex'
                                       alignItems='center'
                                       justifyContent='space-between'
                                    >
                                       <Box display='flex' alignItems='center'>
                                          <Box
                                             className={classes.remainPointFlag}
                                             mr={1}
                                          />
                                          คะแนนคงเหลือ
                                       </Box>
                                       <Box fontSize={20} fontWeight={'bold'}>
                                          {costFormat(item.remainPoints)}
                                       </Box>
                                    </Box>
                                 </Box>
                              </Box>
                           ))}
                     </div>
                  )}
               </Box>
               <Box>
                  <Box margin={'10px'} textAlign={'end'}>
                     <DownloadExcelButton
                        isLoading={isLoadingExcel}
                        onClick={handleDownloadExcel}
                     />
                  </Box>
                  {isLoadingLeaderBoard ? (
                     <LoadingChart show={true} height={300} />
                  ) : (
                     <Box display={'flex'} flexWrap={'wrap'} width={'100%'}>
                        {/* {walletLeaderBoards && walletLeaderBoards.map((item, index) => (
                                        <Box className={classes.tablesContainer} key={index}>
                                            <Box minHeight={100} fontSize={20} fontWeight={"bold"} display={'flex'} justifyContent={'center'} textAlign={'center'} alignItems={'center'}>
                                                {item.name}
                                            </Box>
                                            <MaterialTable
                                                columns={[
                                                    {
                                                        field: 'seq',
                                                        title: 'ลำดับ',
                                                        sorting: false,
                                                        width: 10,
                                                    },
                                                    {
                                                        field: 'nameTh',
                                                        title: 'รายชื่อ',
                                                        sorting: false,
                                                    },
                                                    {
                                                        field: 'point',
                                                        title: 'คะแนน',
                                                        sorting: false,
                                                        render: (rowData) => costFormat(rowData.point),
                                                        align: 'right'
                                                    },
                                                ]}
                                                data={item.wallets}
                                                options={{
                                                    paging: false,
                                                    showTitle: false,
                                                    headerStyle: {
                                                        fontWeight: 'bold',
                                                        backgroundColor: '#F6F6F6'
                                                    },
                                                    actionsColumnIndex: -1,
                                                    addRowPosition: 'first',
                                                    actionsCellStyle: {
                                                        color: '#ccc',
                                                    },
                                                    padding: 'dense',
                                                    pageSize: 10,
                                                    search: false,
                                                    toolbar: false,
                                                    draggable: false,
                                                }}
                                                localization={{
                                                    body: { editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' } },
                                                    header: { actions: 'ตัวจัดการ' },
                                                }}
                                                icons={tableIcons}
                                            />
                                        </Box>
                                    ))} */}
                        {walletLeaderBoards && (
                           <Box className={classes.tablesContainer}>
                              <Box
                                 minHeight={100}
                                 fontSize={20}
                                 fontWeight={'bold'}
                                 display={'flex'}
                                 justifyContent={'center'}
                                 textAlign={'center'}
                                 alignItems={'center'}
                              >
                                 {walletLeaderBoards[0].name}
                              </Box>
                              <MaterialTable
                                 columns={[
                                    {
                                       field: 'seq',
                                       title: 'ลำดับ',
                                       sorting: false,
                                       width: 10,
                                    },
                                    {
                                       field: 'nameTh',
                                       title: 'ชื่อกระเป๋า HR',
                                       sorting: false,
                                    },
                                    {
                                       field: 'point',
                                       title: 'คะแนน',
                                       sorting: false,
                                       render: (rowData) =>
                                          costFormat(rowData.point),
                                       align: 'right',
                                    },
                                 ]}
                                 data={walletLeaderBoards[0].wallets}
                                 options={{
                                    paging: false,
                                    showTitle: false,
                                    headerStyle: {
                                       fontWeight: 'bold',
                                       backgroundColor: '#F6F6F6',
                                    },
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    actionsCellStyle: {
                                       color: '#ccc',
                                    },
                                    padding: 'dense',
                                    pageSize: 10,
                                    search: false,
                                    toolbar: false,
                                    draggable: false,
                                 }}
                                 localization={{
                                    body: {
                                       editRow: {
                                          deleteText:
                                             'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                       },
                                    },
                                    header: { actions: 'ตัวจัดการ' },
                                 }}
                                 icons={tableIcons}
                              />
                           </Box>
                        )}
                        {walletLeaderBoards && (
                           <Box className={classes.tablesContainer}>
                              <Box
                                 minHeight={100}
                                 fontSize={20}
                                 fontWeight={'bold'}
                                 display={'flex'}
                                 justifyContent={'center'}
                                 textAlign={'center'}
                                 alignItems={'center'}
                              >
                                 {walletLeaderBoards[1].name}
                              </Box>
                              <MaterialTable
                                 columns={[
                                    {
                                       field: 'seq',
                                       title: 'ลำดับ',
                                       sorting: false,
                                       width: 10,
                                    },
                                    {
                                       field: 'nameTh',
                                       title: 'ชื่อกระเป๋าธนาคาร',
                                       sorting: false,
                                    },
                                    {
                                       field: 'point',
                                       title: 'คะแนน',
                                       sorting: false,
                                       render: (rowData) =>
                                          costFormat(rowData.point),
                                       align: 'right',
                                    },
                                 ]}
                                 data={walletLeaderBoards[1].wallets}
                                 options={{
                                    paging: false,
                                    showTitle: false,
                                    headerStyle: {
                                       fontWeight: 'bold',
                                       backgroundColor: '#F6F6F6',
                                    },
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    actionsCellStyle: {
                                       color: '#ccc',
                                    },
                                    padding: 'dense',
                                    pageSize: 10,
                                    search: false,
                                    toolbar: false,
                                    draggable: false,
                                 }}
                                 localization={{
                                    body: {
                                       editRow: {
                                          deleteText:
                                             'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                       },
                                    },
                                    header: { actions: 'ตัวจัดการ' },
                                 }}
                                 icons={tableIcons}
                              />
                           </Box>
                        )}
                        {walletLeaderBoards && (
                           <Box className={classes.tablesContainer}>
                              <Box
                                 minHeight={100}
                                 fontSize={20}
                                 fontWeight={'bold'}
                                 display={'flex'}
                                 justifyContent={'center'}
                                 textAlign={'center'}
                                 alignItems={'center'}
                              >
                                 {walletLeaderBoards[2].name}
                              </Box>
                              <MaterialTable
                                 columns={[
                                    {
                                       field: 'seq',
                                       title: 'ลำดับ',
                                       sorting: false,
                                       width: 10,
                                    },
                                    {
                                       field: 'nameTh',
                                       title: 'ชื่อกิจกรรม',
                                       sorting: false,
                                    },
                                    {
                                       field: 'point',
                                       title: 'คะแนน',
                                       sorting: false,
                                       render: (rowData) =>
                                          costFormat(rowData.point),
                                       align: 'right',
                                    },
                                 ]}
                                 data={walletLeaderBoards[2].wallets}
                                 options={{
                                    paging: false,
                                    showTitle: false,
                                    headerStyle: {
                                       fontWeight: 'bold',
                                       backgroundColor: '#F6F6F6',
                                    },
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    actionsCellStyle: {
                                       color: '#ccc',
                                    },
                                    padding: 'dense',
                                    pageSize: 10,
                                    search: false,
                                    toolbar: false,
                                    draggable: false,
                                 }}
                                 localization={{
                                    body: {
                                       editRow: {
                                          deleteText:
                                             'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                       },
                                    },
                                    header: { actions: 'ตัวจัดการ' },
                                 }}
                                 icons={tableIcons}
                              />
                           </Box>
                        )}
                        {walletLeaderBoards && (
                           <Box className={classes.tablesContainer}>
                              <Box
                                 minHeight={100}
                                 fontSize={20}
                                 fontWeight={'bold'}
                                 display={'flex'}
                                 justifyContent={'center'}
                                 textAlign={'center'}
                                 alignItems={'center'}
                              >
                                 {walletLeaderBoards[3].name}
                              </Box>
                              <MaterialTable
                                 columns={[
                                    {
                                       field: 'seq',
                                       title: 'ลำดับ',
                                       sorting: false,
                                       width: 10,
                                    },
                                    {
                                       field: 'nameTh',
                                       title: 'รายชื่อ',
                                       sorting: false,
                                    },
                                    {
                                       field: 'point',
                                       title: 'คะแนน',
                                       sorting: false,
                                       render: (rowData) =>
                                          costFormat(rowData.point),
                                       align: 'right',
                                    },
                                 ]}
                                 data={walletLeaderBoards[3].wallets}
                                 options={{
                                    paging: false,
                                    showTitle: false,
                                    headerStyle: {
                                       fontWeight: 'bold',
                                       backgroundColor: '#F6F6F6',
                                    },
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    actionsCellStyle: {
                                       color: '#ccc',
                                    },
                                    padding: 'dense',
                                    pageSize: 10,
                                    search: false,
                                    toolbar: false,
                                    draggable: false,
                                 }}
                                 localization={{
                                    body: {
                                       editRow: {
                                          deleteText:
                                             'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                       },
                                    },
                                    header: { actions: 'ตัวจัดการ' },
                                 }}
                                 icons={tableIcons}
                              />
                           </Box>
                        )}
                     </Box>
                  )}
               </Box>
            </Box>
         </Paper>
      </div>
   );
};

export default PointCompare;
